import React from 'react';
import { Button } from '../ui/Button';
import { LayoutGrid, BarChart3, Table } from 'lucide-react';

interface DashboardViewToggleProps {
  viewMode: 'overview' | 'charts' | 'tables';
  onViewModeChange: (mode: 'overview' | 'charts' | 'tables') => void;
}

export const DashboardViewToggle: React.FC<DashboardViewToggleProps> = ({
  viewMode,
  onViewModeChange
}) => {
  const viewModes = [
    {
      id: 'overview' as const,
      label: 'Overview',
      icon: LayoutGrid,
      description: 'Quick insights and key metrics'
    },
    {
      id: 'charts' as const,
      label: 'Analytics',
      icon: BarChart3,
      description: 'Visual charts and trends'
    },
    {
      id: 'tables' as const,
      label: 'Data Tables',
      icon: Table,
      description: 'Detailed data with search & sort'
    }
  ];

  return (
    <div className="flex items-center space-x-2 p-1 bg-glass-surface dark:bg-glass-surface-dark-mode rounded-xl border border-glass-border dark:border-glass-border-dark-mode">
      {viewModes.map((mode) => {
        const Icon = mode.icon;
        const isActive = viewMode === mode.id;
        
        return (
          <Button
            key={mode.id}
            variant={isActive ? "default" : "ghost"}
            size="sm"
            onClick={() => onViewModeChange(mode.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-200 ${
              isActive 
                ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/25' 
                : 'text-text-secondary hover:text-text-primary hover:bg-glass-surface/50 dark:hover:bg-glass-surface-dark-mode/50'
            }`}
          >
            <Icon className="w-4 h-4" />
            <span className="font-medium">{mode.label}</span>
          </Button>
        );
      })}
    </div>
  );
};

export default DashboardViewToggle;
